import { Util } from '../../common/util/util';
import { ICatalogService } from '../../shared/types/services';

export const getServices = (
  services: ICatalogService[],
  windowWidth: number
) => {
  const content: ICatalogService[] = [];
  let width = 240;
  for (let i = 0; i < services.length; i++) {
    if (
      Util.getTextWidth(services[i].title, '14px open sans') + 41 + width <
      windowWidth
    ) {
      width += 41 + Util.getTextWidth(services[i].title, '14px open sans');
      content.push(services[i]);
    } else {
      return { content, servicesLeft: services.slice(i, services.length) };
    }
  }

  return { content, servicesLeft: [] };
};
